var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.createdPaymentTransaction &&
    _vm.paymentGatewayMethod === _vm.paymentGatewayMethodEnum.QR_CODE
    ? _c("PaymentGateway", {
        ref: "paymentGateway",
        attrs: {
          createdPaymentTransaction: _vm.createdPaymentTransaction,
          country: _vm.country,
          countryCode: this.countryCode
        },
        on: { retry: _vm.retryTransaction, newPayment: _vm.handleResetForm }
      })
    : _vm.createdPaymentTransaction &&
      _vm.paymentGatewayMethod ===
        _vm.paymentGatewayMethodEnum.ONLINE_BANKING_PAYNOW
    ? _c("BankingOnlinePayNow", {
        ref: "bankingOnlinePayNow",
        attrs: {
          transactionUid: _vm.createdPaymentTransaction.transactionUid,
          totalAmount: _vm.totalAmount,
          currencyCode: _vm.currencyCode
        }
      })
    : _c(
        "Layout",
        {
          attrs: {
            hasChangedData: _vm.hasChangedData,
            openModalChangeCountry: _vm.isOpenModalChangeCountry
          },
          on: {
            confirmChangeFlag: _vm.handleConfirmChangeFlag,
            "update:openModalChangeCountry": function($event) {
              _vm.isOpenModalChangeCountry = $event
            },
            "update:open-modal-change-country": function($event) {
              _vm.isOpenModalChangeCountry = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("section", { staticClass: "content ep__main_content pt-80" }, [
                _c(
                  "div",
                  {
                    key: "payPoContainer",
                    staticClass: "container",
                    attrs: { "data-form-container": "" }
                  },
                  [
                    _c("EpPageTitle", [
                      _vm._v(
                        " " +
                          _vm._s(this.getDisplayText("payPoPage_payPO_title")) +
                          " "
                      )
                    ]),
                    _c("hr", { staticClass: "ep__border__line" }),
                    _c("FloatingError", {
                      attrs: { floatingErrors: _vm.floatingErrors }
                    }),
                    _c("EpPOPaymentHeader", {
                      attrs: { countryCode: _vm.country && _vm.country.code }
                    }),
                    _vm._l(_vm.poPaymentList, function(po, index) {
                      return _c("EpPOPaymentRow", {
                        key: po.no,
                        attrs: {
                          poItem: po,
                          index: index,
                          countryCode: _vm.country && _vm.country.code
                        },
                        on: {
                          blur: function($event) {
                            return _vm.handlePoNumberInputBlur(po)
                          },
                          remove: function($event) {
                            return _vm.handleRemovePO(po)
                          },
                          "update:poNumber": function($event) {
                            return _vm.handleUpdatePoNumber(po, $event)
                          }
                        }
                      })
                    }),
                    _c("EpPOPaymentRowManagement", {
                      attrs: {
                        blsCount: _vm.totalBls,
                        maxBls: _vm.MAX_BLS,
                        posCount: _vm.totalPos,
                        maxPos: _vm.MAX_POS,
                        countryCode: this.countryCode
                      },
                      on: { add: _vm.addPO }
                    }),
                    _c("div", { staticClass: "content__frame mb-16" }, [
                      _c("div", { staticClass: "row ml-0 mr-0" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-12 col-12 d-flex flex-column form__totalRight"
                          },
                          [
                            _c("TotalAmount", {
                              attrs: {
                                totalAmount: _vm.totalAmount,
                                countryCode: this.countryCode,
                                errorFn: function(max, exceed, currency) {
                                  return _vm.getTextByCountry(
                                    this$1.countryCode,
                                    "payPOPage_totalAmount_label_errorMsg_exceedMax",
                                    [currency, max]
                                  )
                                }
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "pt-24 d-flex flex-column " },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-end align-items-end"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex h-100" },
                                      [
                                        _c(
                                          "EpButton",
                                          {
                                            attrs: {
                                              "data-testid":
                                                "proceed-to-pay-button",
                                              disabled: !_vm.canProceedToPay
                                            },
                                            on: {
                                              click: _vm.openModalProceedToPay
                                            }
                                          },
                                          [_vm._v("Proceed to Pay")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _c("EpPOProceedToPay", {
                      attrs: { isOpen: _vm.isOpenModalProceedToPay },
                      on: {
                        confirm: _vm.handleConfirmProceedToPay,
                        discard: _vm.handleDiscardProceedToPay
                      }
                    })
                  ],
                  2
                )
              ]),
              _c("loading", { attrs: { isRequesting: _vm.isCreatingPayment } }),
              _c("loading", {
                attrs: {
                  isRequesting: _vm.isRetryingTransaction,
                  title: "Retrying your transaction. Please wait..."
                }
              })
            ],
            1
          ),
          _c("div", {
            attrs: { "data-testid": "pageRedirectForm" },
            domProps: { innerHTML: _vm._s(_vm.pageRedirectForm) }
          })
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }